export default "__VITE_ASSET__muzoJ1m3__"